import UserCreator from "../objectCreator/UserCreator";
import UserHelper from "../helpers/UserHelper";
import JsTypeInspector from "../../serviceLayer/validators/JsTypeInspector";
import ProcessStatus from "../../utils/enumerations/ProcessStatus";



const createUser = function(createUserPageCallback){

     const form = document.getElementById('registrationCustomerForm1');
     if(form != null){

        //console.log("form", form);
        const userObj = UserCreator.createUserObjectFromRegistrationForm(form);
        let errorsReport = UserHelper.processCreateUserInputValidation(userObj);
        const reportIsNullOrEmpty = JsTypeInspector.objectIsNullOrEmpty(errorsReport);       
        //console.log("reportIsNullOrEmpty", reportIsNullOrEmpty); // Optional for debugging
        if(!reportIsNullOrEmpty){
            errorsReport.status = ProcessStatus.FailedWithErrors;

            return errorsReport;
        }

        UserHelper.processHttpRequestCreateUser(userObj, createUserPageCallback);
     }
}

const updatePassword = function(updatePasswordPageCallback){

     const form = document.getElementById('updatePasswordForm1');
     //console.log("updatePassword-form", form);
     if(form != null){
        const password = form[0].value;
        const confirmPassword = form[1].value;    

        let errorsReport = UserHelper.processUpdatePasswordInputValidation(password, confirmPassword);
        const reportIsNullOrEmpty = JsTypeInspector.objectIsNullOrEmpty(errorsReport);       
        //console.log("reportIsNullOrEmpty", reportIsNullOrEmpty); // Optional for debugging
        if(!reportIsNullOrEmpty){
            errorsReport.status = ProcessStatus.FailedWithErrors;

            return errorsReport;
        }

        UserHelper.processHttpRequestUpdatePassword(password, confirmPassword, updatePasswordPageCallback);
    }
}


const UserManager = Object.freeze({
    createUser : createUser,
    updatePassword : updatePassword
});

export default UserManager;